export class AuthInfo {
  public eMail: string;
  public token: string;
  firstName: any;
  lastName: any;
  scopeId: string;
  isPlatformAdmin: boolean;
}
